<template>
	<div>
		<img class="mx-auto block h-12 relative z-10" :src="require('@/assets/pace-logo.svg')">
		<card class="max-w-sm mx-auto mt-4 relative z-10">
			<h1 class="border-b text-2xl font-light md:text-5xl">Thanks!</h1>
			<p class="mt-2">Thank you for your interest in working with us at Pace International! Our team will review your resume and if you meet criteria for this position a member of Human Resources will be in contact with you. Thank you again for your interest in our company.</p>

			<div class="flex">
				<a href="https://www.paceintl.com/about-pace/" class="no-underline w-full text-center bg-green-dark text-white text-xl py-2 rounded mt-4">About Us</a>
			</div>
		</card>
	</div>
</template>

<script>
	import Card from '@/components/Card'
	import store from '@/store'

	export default {
		components: {
			Card,
		},

		beforeRouteEnter(to, from, next) {
			if (!store.state.hasSubmitted) {
				window.location = 'https://www.paceintl.com/careers'
				
				return
			}

			next()
		},

		mounted() {
			localStorage.clear()
		}
	}
</script>
